module.exports = __webpack_public_path__ + "img/ESF.1b7daa91.png";